import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';

const Ownership = () => {
  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Box sx={{ textAlign: 'center', mb: 5 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Ownership
        </Typography>
      </Box>

      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="body1" paragraph>
          <strong>NEEHAW LLC</strong> is the sole owner and operator of{' '}
          <strong>peaklabspro.com</strong>.
        </Typography>

        <Typography variant="body1" paragraph>
          NEEHAW LLC owns all intellectual property, software, applications,
          games, websites, services, APIs, branding, logos, source code,
          content, and other digital products that are published under or
          associated with the PeakLabsPro platform.
        </Typography>

        <Typography variant="body1" paragraph>
          This includes, but is not limited to:
        </Typography>

        <Box component="ul" sx={{ pl: 3 }}>
          <li>
            <Typography>peaklabspro.com</Typography>
          </li>
          <li>
            <Typography>All PeakLabsPro web applications</Typography>
          </li>
          <li>
            <Typography>All PeakLabsPro mobile applications</Typography>
          </li>
          <li>
            <Typography>
              All PeakLabsPro games and interactive experiences
            </Typography>
          </li>
          <li>
            <Typography>Associated APIs and online services</Typography>
          </li>
          <li>
            <Typography>
              Related domains, subdomains, branding, and digital assets
            </Typography>
          </li>
        </Box>

        <Typography variant="body1" sx={{ mt: 3 }}>
          Unless otherwise stated, all content and products available through
          the PeakLabsPro platform are the property of NEEHAW LLC and are
          protected by applicable copyright, trademark, and intellectual
          property laws.
        </Typography>
      </Paper>
    </Container>
  );
};

export default Ownership;
